/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type StakeMutationVariables = Types.Exact<{
	input: Types.StakingActionInput;
}>;

export type StakeMutation = {
	__typename?: "Mutation";
	stake:
		| {
				__typename: "StakingAction";
				id: string;
				type: Types.StakingActionType;
				walletId?: string | null;
				assetAmount: { __typename?: "CurrencyAmount"; value: string };
				asset: { __typename?: "StakeableAsset"; assetId: string };
				balanceAfter: { __typename?: "CurrencyAmount"; value: string };
				createdAt: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
		  }
		| { __typename: "StakingActionInProgress"; _?: boolean | null };
};

export const StakeDocument = gql`
	mutation stake($input: StakingActionInput!) {
		stake(input: $input) {
			__typename
			... on StakingAction {
				id
				assetAmount {
					value
				}
				type
				walletId
				asset {
					assetId
				}
				balanceAfter {
					value
				}
				createdAt {
					iso8601
					unixTimestamp
				}
			}
			... on StakingActionInProgress {
				_
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class StakeGQLService extends Apollo.Mutation<StakeMutation, StakeMutationVariables> {
	document = StakeDocument;
	client = "staking";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
